import { validateBuildingUses } from "../services/ValidateBuildingProjectService";
import type { WizardProjectType } from "../types/WizardProjectType";

/** Whether every row of a mixed-use table is complete; a single use always is. Reference areas play no part. */
export const buildingUsesValid = (project: WizardProjectType): boolean => validateBuildingUses(project);
